// extracted by mini-css-extract-plugin
export default {"primary-course":"selectPrimaryCourse_primary-course__G0dMS"};